<template>
  <Page route-path="/about.html">
    <div class="body">
      <div class="head-image">
        <div class="head-image-title">科技创造未来</div>
      </div>
      <div class="about-us">
        <div class="title">关于我们</div>
        <div class="aboutBox">
          <div class="about-us-box">
            <div class="title">
              <span class="company name">链聚信息科技</span
              ><span class="company">是一家信息技术高科技公司。</span>
            </div>
            <!-- <div class="text" v-for="(item, index) of aboutUs.text" :key="index">{{ item }}</div> -->
            <div class="text">
              我们专注在低代码、云计算、区块链等信息技术领域，拥有创新、灵活和多元的产品体系，提供电子档案管理系统、低代码平台、区块链平台，以及IT咨询和软件定制服务。我们拥有多项软件著作权、专利等知识产权成果。
            </div>
            <div class="text">
              我们团队由来自京东、美团等知名企业的前高管和高级技术人员组成，具有广阔视野、先进技术和丰富经验。我们秉持“客户为先、创新引领”的工程师文化理念，为客户提供卓越价值。
            </div>
            <div class="text">
              我们持续在低代码、大数据、云计算、区块链、人工智能方面创新技术应用，在物流、通信、金融、电子、政务、智慧教育等应用场景探索研发有自主知识产权的产品和解决方案，服务范围覆盖国内外多地区。
            </div>
          </div>
        </div>
        <div class="about-us-foot">
          <div class="about-us-image-background"></div>
          <div class="about-us-image">
            <img src="@/assets/about/about_us_short.png" />
          </div>

          <div class="about-us-content">
            <div class="about-us-foot-1">
              <div>公司文化</div>
              <div>客户为先，创新致远，诚信共赢</div>
            </div>
            <div class="about-us-foot-2">
              <div>公司使命</div>
              <div>用科技创造未来</div>
            </div>
          </div>
        </div>
      </div>

      <div class="core">
        <div class="title">创始人</div>
        <div class="core-text">
          <div class="core-text-box">
            <div class="core-content">
              <div class="core-content-name">
                <span>黄海泉</span><span class="name-divider">/</span
                ><span>HUANG HAI QUAN</span>
              </div>
              <div class="core-content-synopsis1">创始人 & CEO</div>
              <div
                class="core-content-name"
                style="
                  height: 1px;
                  background: #2e64f3;
                  border-radius: 0px 0px 0px 0px;
                  opacity: 0.4;
                "
              ></div>
              <div class="core-content-synopsis2">
                <p>
                  黄海泉，链聚信息科技的创始人，任首席执行官(CEO），专注于科技产品创新与前沿技术趋势。<br />
                  在创立链聚信息科技之前，黄海泉先生担任京东科技集团区块链技术总监，人才委员会委员。任职期间创建了京东区块链平台
                  JDChain，获京东集团金项奖。
                  更早前曾服务于用友、中国电信等知名企业。
                </p>
                <p>
                  黄海泉先生是信息技术领域的资深专家，有16+年技术研发管理经验，发明专利
                  27
                  项，擅长大型分布式系统和企业平台架构，还是开源的积极贡献者，
                  创建的开源项目 JDChain 是重要的国产自主区块链平台之一。
                </p>
                <p>
                  此外，还广泛参与国家技术标准制定与行业协会，积极推动技术与产业应用发展。<br />
                  •工信部“中国区块链技术和产业发展论坛”理事会工作组成员。
                  <br />
                  •工信部“中国区块链开发大赛”第二、第三、第四届专家评委。
                  <br />
                  •工信部《中国区块链技术和应用发展研究报告(2018)》编撰组成员。
                  <br />
                  •《信息安全技术 区块链技术安全框架》国家标准起草专家组成员。
                  <br />
                  • “中国工业与应用数学学会(CSIAM)”区块链专业委员会委员。
                </p>
              </div>
              <div class="core-content-synopsis3"></div>
            </div>
            <div class="core-image">
              <img src="@/assets/home/hhq.png" />
            </div>
          </div>
        </div>
      </div>

      <div class="qualification" style="padding-bottom: 0;">
        <div class="title">知识产权</div>
        <div class="knowlist">
          <div class="know">
            <template v-for="i in 4" :key="i">
              <div class="know-item">
                <img src="@/assets/about/flexue.png" />
                <h4>凤栖前端开发平台</h4>
                <p>2025年11月</p>
              </div>
              <div class="know-item">
                <img v-lazy="require('@/assets/about/digital.png')" />
                <h4>数字化综合管理平台</h4>
                <p>2025年11月</p>
              </div>
              <div class="know-item">
                <img v-lazy="require('@/assets/about/emall.png')" />

                <h4>链聚电商平台</h4>
                <p>2025年11月</p>
              </div>
              <div class="know-item">
                <img src="@/assets/about/app.png" />
                <h4>数转精灵</h4>
                <p>2025年11月</p>
              </div>
              <div class="know-item">
                <img v-lazy="require('@/assets/about/rz2.png')" />

                <h4>星河低代码平台</h4>
                <p>2021年9月</p>
              </div>
              <div class="know-item">
                <img v-lazy="require('@/assets/about/rz1.png')" />

                <h4>千尺链区块链</h4>
                <p>2021年4月</p>
              </div>
              <div class="know-item">
                <img v-lazy="require('@/assets/about/zl1.png')" />

                <h4>零信任网络访问系统</h4>
                <p>2022年6月</p>
              </div>
              <div class="know-item">
                <img v-lazy="require('@/assets/about/sb1.png')" />

                <h4>商标：链聚</h4>
                <p>2022年6月</p>
              </div>
              <div class="know-item">
                <img v-lazy="require('@/assets/about/sb2.png')" />

                <h4>商标：千尺</h4>
                <p>2022年6月</p>
              </div>
              <div class="know-item">
                <img v-lazy="require('@/assets/about/sb3.png')" />

                <h4>商标：千尺链</h4>
                <p>2022年6月</p>
              </div>
              <div class="know-item">
                <img v-lazy="require('@/assets/about/sb4.png')" />

                <h4>商标：千尺溯源</h4>
                <p>2022年6月</p>
              </div>
            </template>
          </div>
        </div>

        <!-- <div class="our-copyrights">
          <template v-if="isMobile">
            <div class="copyright-list-box">
              <div class="copyright-item">
                <span class="title">软著</span>
                <copyright-software></copyright-software>
              </div>
              <div class="copyright-item">
                <span class="title">专利</span>
                <copyright-patent></copyright-patent>
              </div>
              <div class="copyright-item">
                <span class="title">商标</span>
                <copyright-trademark></copyright-trademark>
              </div>
            </div>
          </template>
          <template v-else>
            <el-tabs
              v-model="activeName"
              class="demo-tabs"
              @tab-click="handleClick"
            >
              <el-tab-pane label="软著" name="first">
                <copyright-software></copyright-software>
              </el-tab-pane>
              <el-tab-pane label="专利" name="second">
                <copyright-patent></copyright-patent>
              </el-tab-pane>
              <el-tab-pane label="商标" name="third">
                <copyright-trademark></copyright-trademark>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div> -->
      </div>

      <div class="qualification">
        <div class="title">企业发展里程碑</div>
        <div class="our-copyrights">
          <el-timeline>
            <el-timeline-item center placement="top">
              <el-card>
                <h4>2025年</h4>
                <p>
                  数字化综合管理平台赋能企业转型
                  自主研发的数字化综合管理平台，已帮助数十家企业低成本完成数字化转型，实现降本增效。
                </p></el-card
              >
            </el-timeline-item>
            <el-timeline-item center placement="top">
              <el-card>
                <h4>2024年</h4>
                <p>
                  链聚电子商城系统发布
                  推出支持SaaS与私有化部署的电子商城系统，助力企业快速搭建安全、可扩展的电商平台。
                </p></el-card
              >
            </el-timeline-item>
            <el-timeline-item center placement="top">
              <el-card>
                <h4>2023年</h4>
                <p>
                  星河低代码平台实现规模化应用
                  星河低代码平台成功落地多行业项目，帮助客户大幅降低开发成本，提升数字化效率。
                </p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item center placement="top">
              <el-card>
                <h4>2022年</h4>
                <p>
                  知识产权成果丰硕 获得区块链相关专利。
                  同时获得多项软件著作权，构建完整知识产权体系。
                </p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item center placement="top">
              <el-card>
                <h4>2021年</h4>
                <p>
                  商标与核心技术框架落地 获得“链聚”“千尺链”等商标。
                  推出自主研发的凤栖前端框架与星河低代码平台，奠定技术产品化基础。
                </p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item center placement="top">
              <el-card>
                <h4>2020年</h4>
                <p>
                  区块链电子档案系统通过国家试点
                  自主研发的基于区块链技术的电子档案系统，参与了全国第三批数转发票试点，标志着技术落地能力获得国家级认可。
                </p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item center placement="top">
              <el-card>
                <h4>2018年</h4>
                <p>
                  公司成立
                  专注于软件研发与技术创新，致力于为企业提供数字化解决方案。
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>

      <div class="contact-us">
        <div class="title">联系我们</div>
        <div class="contact-list">
          <div
            class="contact-list-item"
            v-for="(item, index) of contactList"
            :key="index"
          >
            <div class="item-right">
              <div class="item-right-name">{{ item.name }}</div>
              <div class="item-right-name2">{{ item.name2 }}</div>
            </div>
            <img :src="item.img" alt="" style="height: 120px; width: 120px" />
          </div>
        </div>

        <div class="map">
          <div class="address">
            <div class="item-right">
              <div class="item-right-name">邮箱</div>
              <div class="item-right-name2">service@linkgie.com</div>
            </div>
            <div class="item-right two">
              <div class="item-right-name">公司地址</div>
              <div class="item-right-name2">
                湖南省长沙市岳麓区梅溪湖街道环湖路80号中海熙湾T6栋1007室
              </div>
            </div>
          </div>
          <el-image
            class="map-image"
            :src="require('@/assets/about/map2.png')"
            :zoom-rate="1.2"
            :preview-src-list="srcList"
            :initial-index="0"
            fit="cover"
            alt=""
            :hide-on-click-modal="true"
          />
        </div>
      </div>
    </div>
  </Page>
</template>
<script>
import CopyrightPatent from "./copyright-patent.vue";
import CopyrightSoftware from "./copyright-software.vue";
import CopyrightTrademark from "./copyright-trademark.vue";

import { ResponsiveBase } from "../../layout/reponsive-base";

export default {
  name: "aboutus",

  components: {
    CopyrightSoftware,
    CopyrightPatent,
    CopyrightTrademark,
  },

  mixins: [ResponsiveBase],

  data() {
    return {
      activeName: "first",
      chooseIndex: 1,
      aboutUs: {
        title: "",
        text: [],
      },
      contactList: [
        {
          img: require("../../assets/footer/gzh.png"),
          name: "微信公众号",
          name2: "扫码关注了解更多产品内容",
        },
        {
          img: require("../..//assets/footer/sph.png"),
          name: "微信视频号",
          name2: "扫码关注了解更多产品内容",
        },
        {
          img: require("../../assets/footer/dy.png"),
          name: "抖音",
          name2: "扫码关注了解更多产品内容",
        },
      ],
      srcList: [require("../../assets/about/map2.png")],
    };
  },
  created() {},
  inject: ["pageIndicator"],
  computed: {},

  mounted() {},

  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    choose(index) {
      this.chooseIndex = index;
    },
  },
};
</script>
<style lang="less" scoped>
.body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px;
  padding-top: 65px;
}
.knowlist {
  margin-top: 80px;
  overflow: hidden;
  max-width: 1200px;
  width: 100%;
  .know {
    display: flex;
    width: max-content; // ⭐ 核心
    animation: scroll-left 50s linear infinite;

    @keyframes scroll-left {
      from {
        transform: translateX(0);
      }
      to {
        transform: translateX(-50%);
      }
    }
    .know-item {
      flex-shrink: 0; // ⭐ 必须
      margin-right: 30px; // ❌ 不用 gap
      text-align: center;
      img {
        max-width: 390px;
        width: unset;
        max-height: 325px;
      }
      h4 {
        font-size: 18px;
        line-height: 18px;
        font-weight: 400;
        text-align: center;
        color: #000000;
        margin: 20px 0 0;
      }
      p {
        margin-top: 8px;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        color: #7a7a7a;
      }
    }
  }
}

.title {
  font-size: 36px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #040420;
  height: 36px;
  line-height: 36px;

  @media screen and (max-width: 850px) {
    font-size: 24px;
  }
}

.company {
  font-size: 24px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 400;
  color: #040420;
  height: 36px;
  line-height: 36px;

  @media screen and (max-width: 850px) {
    font-size: 18px;
    line-height: 24px;
  }
}

.company.name {
  font-size: 32px;
  font-weight: 500;
  margin-right: 8px;

  @media screen and (max-width: 850px) {
    font-size: 22px;
  }
}

.head-image {
  //background-image: url(@/assets/information/information_banner.png);
  background: url(../../assets/about/banner.png) no-repeat center center;
  background-size: 100% 100%;
  width: 100%;
  height: 380px;
  //padding: 135px;
  display: flex;
  justify-content: center;
  align-items: center;

  .head-image-title {
    font-size: 40px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
    text-align: center;

    @media screen and (max-width: 850px) {
      font-size: 30px;
    }
  }
}

.about-us {
  padding: 100px 0px 0px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .aboutBox {
    width: 100%;
    max-width: 1280px;
    display: flex;
    flex-direction: column;
    position: relative;

    @media screen and(max-width:1280px) {
      padding-left: 30px;
      padding-right: 30px;
    }
  }

  .about-us-box {
    width: 100%;
    max-width: 1280px;
    padding-top: 60px;

    display: flex;
    flex-direction: column;
    row-gap: 15px;

    .title {
      height: auto;
      font-size: 24px;
      color: #727272;
      font-family: Source Han Sans CN-Regular;
      line-height: 40px;
    }

    .text {
      font-size: 18px;
      color: #727272;
      font-family: Source Han Sans CN-Regular;
      line-height: 32px;

      @media screen and (max-width: 850px) {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }

  .about-us-foot {
    width: 100%;
    height: 172px;
    margin-top: 25px;
    position: relative;
    display: flex;
    align-items: center;

    background-color: #f0f2f9;

    .about-us-foot-1 {
      margin-right: 8%;
    }

    .about-us-foot-1 div:first-child {
      font-size: 24px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #040420;
      border-left: 6px solid #2e64f3;
      padding-left: 12px;
      line-height: 24px;

      @media screen and (max-width: 850px) {
        font-size: 18px;
        line-height: 18px;
      }
    }

    .about-us-foot-1 div:last-child {
      font-size: 18px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #727272;
      line-height: 32px;
      margin-top: 20px;
      padding-left: 18px;

      @media screen and (max-width: 850px) {
        font-size: 14px;
        line-height: 24px;
      }
    }

    .about-us-foot-2 {
      min-width: 144px;
    }

    .about-us-foot-2 div:first-child {
      font-size: 24px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #040420;
      border-left: 6px solid #2e64f3;
      padding-left: 12px;
      line-height: 24px;

      @media screen and (max-width: 850px) {
        font-size: 18px;
        line-height: 18px;
      }
    }

    .about-us-foot-2 div:last-child {
      font-size: 18px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #727272;
      line-height: 32px;
      margin-top: 20px;
      padding-left: 18px;
      @media screen and (max-width: 850px) {
        font-size: 14px;
        line-height: 24px;
      }
    }

    @media screen and (max-width: 1000px) {
      margin-top: 0px;
      height: 344px;
    }

    @media screen and(max-width:540px) {
      .about-us-foot-1 {
        margin-right: 0px;
        width: 50%;
        min-width: 270px;
      }

      .about-us-foot-1 div:last-child {
        margin: 0px;
      }

      .about-us-foot-2 {
        margin-right: 0px;
        width: 50%;
        min-width: 270px;
      }

      .about-us-foot-2 div:last-child {
        margin: 0px;
      }
    }
  }
}

.about-us-image-background {
  position: absolute;
  top: 0px;
  left: 50%;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  background-color: #ffffff;
  transform: skewX(-15deg);

  @media screen and (max-width: 1000px) {
    top: 0px;
    left: 0px;
    width: 100%;
    height: 172px;
    transform: none;
  }
}

.about-us-image {
  position: absolute;
  top: 0px;
  left: 50%;
  width: 50%;
  z-index: 1000;
  height: 100%;
  max-width: 640px;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  @media screen and (max-width: 1000px) {
    top: 0px;
    left: 0px;
    right: 0px;
    width: 100%;
    height: 50%;
    max-width: none;

    justify-content: center;

    img {
      padding: 0px 30px;
    }
  }
}

.about-us-image img {
  width: 490px;
  height: 172px;
  max-width: 640px;
  object-fit: scale-down;

  @media screen and(max-width:540px) {
    width: 100%;
    height: 100%;
  }
}

.about-us-content {
  position: absolute;
  right: 50%;
  width: 50%;
  max-width: 640px;
  height: 100%;
  padding: 0px 60px 0 0;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  @media screen and (max-width: 1000px) {
    width: 100%;
    max-width: 100%;
    height: 172px;
    padding: 0px;

    top: 172px;
    left: 0px;
    right: 0px;

    justify-content: center;
  }

  @media screen and (max-width: 540px) {
    display: flex;
    flex-direction: column;
    justify-items: center;
    align-items: center;
    row-gap: 20px;
  }
}

.core {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.core .title {
  height: 258px;
  padding-bottom: 100px;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
}

.core-text {
  background: #f0f2f9;
  width: 100%;
  display: flex;
  justify-content: center;
}

.core-text-box {
  width: 100%;
  max-width: 1280px;
  height: 650px;
  display: flex;
  justify-content: space-between;
  padding: 30px 0px 0px 0px;
  position: relative;

  @media screen and(max-width: 1280px) {
    padding: 30px 30px 0 30px;
  }

  @media screen and(max-width: 1100px) {
    height: auto;
  }
}

.core-content {
  max-width: 700px;
  width: 60%;

  z-index: 1000;

  .core-content-name {
    min-width: 500px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
  }

  .core-content-name span {
    font-size: 36px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #040420;

    word-break: break-word;
  }

  .core-content-name .name-divider {
    margin: 0px 8px;
  }

  .core-content-synopsis1 {
    font-size: 18px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #040420;
    padding: 11px 0px 32px;
  }

  .core-content-synopsis2 {
    padding: 36px 0px 28px;
  }

  .core-content-synopsis2 div {
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 32px;
    padding: 10px 0px;
  }

  .core-content-synopsis2 p {
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
    padding: 10px 0px 0px 0px;
    word-break: break-word;
  }

  @media screen and (max-width: 1100px) {
    width: 100%;
    max-width: unset;

    .core-content-name {
      min-width: unset;
      width: 45%;
      margin-top: 20px;
    }

    // .core-content-name span {
    //   font-size: 28px;
    // }

    .core-content-name .name-divider {
      visibility: hidden;
    }
  }

  @media screen and (max-width: 850px) {
    width: 100%;

    .core-content-name {
      min-width: unset;
      width: 45%;
      margin-top: 20px;
    }

    .core-content-name span {
      font-size: 24px;
    }

    .core-content-name .name-divider {
      visibility: hidden;
    }

    .core-content-synopsis1 {
      font-size: 18px;
    }

    .core-content-synopsis2 {
      padding: 60px 0 28px 0;
      font-size: 14px;

      p {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }

  .core-content-synopsis3 {
    font-size: 16px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 36px;
  }
}

.core-image {
  width: 35%;
  max-width: 500px;
  min-width: 300px;
  height: 100%;
  position: relative;
  bottom: 0px;
  right: -60px;

  @media screen and(max-width: 1280px) {
    right: 0px;
  }

  @media screen and(max-width: 1100px) {
    width: 340px;
    height: 340px;
    max-width: unset;
    min-width: unset;
    right: -60px;
    overflow: hidden;
    border-radius: 170px;

    position: absolute;
    top: -70px;
    right: 30px;
  }

  @media screen and(max-width: 850px) {
    width: 280px;
    height: 280px;
    max-width: unset;
    min-width: unset;
    right: -60px;
    overflow: hidden;
    border-radius: 150px;

    position: absolute;
    top: -50px;
    right: 30px;
  }
}

.core-image img {
  width: 490px;
  padding: 0px;
  position: absolute;
  bottom: 0;

  @media screen and(max-width: 1100px) {
    width: 420px;
    top: 0;
    left: 0px;
  }

  @media screen and(max-width: 850px) {
    width: 360px;
    top: 0;
    left: 0px;
  }
}

.qualification {
  padding: 100px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media screen and (max-width: 1280px) {
    padding: 100px 30px;
  }

  @media screen and (max-width: 600px) {
    padding: 100px 15px;
  }

  .our-copyrights {
    width: 100%;
    max-width: 1280px;
    margin-top: 60px;

    .copyright-list-box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      row-gap: 28px;

      .copyright-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .title {
          font-size: 24px;
          margin-bottom: 28px;
          @media screen and (max-width: 850px) {
            font-size: 18px;
          }
        }
      }
    }
    h4{
      margin: 20px auto;
      font-size: 24px;
      color:#2e64f3
    }
  }
}

.pilot-units {
  //padding-top: 100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.pilot-units-text {
  margin-top: 30px;
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #727272;
  line-height: 30px;
}

.pilot-units-content {
  padding: 60px 0px;
  width: 1280px;
  margin: 0 auto;
}

.select-box {
  width: 225px;
  height: 60px;
  background: linear-gradient(360deg, #f8f9fd 0%, #ffffff 100%);
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #e4e6ee;
  margin-right: 16px;
  display: flex;
  align-items: baseline;
  padding: 10px 0px 0px 10px;
  //border-radius: 7px;
  /*圆角弧度为7px*/
  position: relative;
}

.down {
  background: #2e64f3;
  border: 2px solid #2e64f3;

  &::before {
    content: "";
    width: 0;
    height: 0;
    border: 5px solid;
    position: absolute;
    bottom: -12px;
    left: 107px;
    border-color: #2e64f3 transparent transparent;
  }

  &::after {
    content: "";
    width: 0;
    height: 0;
    border: 5px solid;
    position: absolute;
    bottom: -12px;
    left: 107px;
    border-color: #2e64f3 transparent transparent;
  }
}

// .select-box::before {
//     content: '';
//     width: 0;
//     height: 0;
//     border: 5px solid;
//     position: absolute;
//     bottom: -12px;
//     left: 112px;
//     border-color: #2E64F3 transparent transparent;

// }

// .select-box::after {
//     content: '';
//     width: 0;
//     height: 0;
//     border: 5px solid;
//     position: absolute;
//     bottom: -12px;
//     left: 112px;
//     border-color: #2E64F3 transparent transparent;
// }
.select-box span:first-child {
  height: 44px;
  font-size: 36px;
  font-family: DIN-Bold, DIN;
  font-weight: bold;
  color: #727272;
  line-height: 30px;
}

.select-box span:nth-child(2) {
  height: 17px;
  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #727272;
  line-height: 30px;
  margin-left: 8px;
}

.select-box span:last-child {
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #727272;
  line-height: 30px;
  margin-left: 10px;
}

.down span:first-child {
  height: 44px;
  font-size: 36px;
  font-family: DIN-Bold, DIN;
  font-weight: bold;
  color: #ffffff;
  line-height: 30px;
}

.down span:nth-child(2) {
  height: 17px;
  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  margin-left: 8px;
}

.down span:last-child {
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  margin-left: 10px;
}

.select_tags {
  display: flex;
}

.select-detail {
  width: 1280px;
  height: 660px;
  background: linear-gradient(360deg, #f8f9fd 0%, #ffffff 100%);
  opacity: 1;
  border: 1px solid #e4e6ee;
  margin-top: 21px;
  padding: 40px 60px 60px 60px;
}

.select-detail div:first-child {
  font-size: 32px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;
  color: #040420;
  line-height: 32px;
}

.select-detail div:nth-child(2) {
  height: 18px;
  font-size: 18px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #727272;
  line-height: 30px;
  margin: 32px 0px;
}

.detail-centent {
  margin: 0px !important;
}

.detail-centent div:first-child {
  text-align: center;
  width: 100%;
}

.detail-centent div:last-child {
  text-align: center;
  width: 100%;
  margin-top: 20px;
  font-size: 16px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #727272;
  line-height: 30px;
}

.detail-centent {
  height: 100% !important;
  margin-right: 10px !important;
}

.select-detail2 {
  width: 1280px;
  height: 660px;
  background: linear-gradient(360deg, #f8f9fd 0%, #ffffff 100%);
  opacity: 1;
  border: 1px solid #e4e6ee;
  margin-top: 21px;
  padding: 40px 60px 60px 60px;

  .introduce {
    font-size: 18px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
    margin-top: 32px;
  }

  .title {
    font-size: 32px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    line-height: 32px;
    color: #040420;
  }

  .foot-title {
    font-size: 24px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    line-height: 24px;
    margin-top: 36px;
    margin-bottom: 24px;
  }

  .foot-introduce {
    font-size: 18px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
  }
}

.select-detail2-center {
  display: flex;
  justify-content: space-between;

  .select-detail2-center-left {
    width: 640px;
  }

  .select-detail2-center-left div:first-child {
    font-size: 24px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #040420;
    line-height: 24px;
    margin-top: 24px;
    margin-bottom: 20px;
  }

  .select-detail2-center-left div:last-child {
    font-size: 18px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #727272;
    line-height: 30px;
  }
}

.contact-us {
  padding: 40px 0px 80px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media screen and (max-width: 1280px) {
    padding: 40px 28px 28px 28px;
  }

  @media screen and (max-width: 600px) {
    padding: 20px 14px 20px 14px;
  }

  .contact-list {
    padding: 60px 0px 0px;
    width: 100%;
    max-width: 1280px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    column-gap: 15px;

    @media screen and (max-width: 850px) {
      flex-direction: column;
      row-gap: 12px;
      padding: 60px 0 0 0;
    }

    .contact-list-item {
      width: 33%;
      max-width: 408px;
      height: 144px;
      background: #f0f2f9;
      //box-shadow: 5px 5px 15px 1px rgba(96, 129, 217, 0.15);
      // border-radius: 12px 12px 12px 12px;
      opacity: 1;
      padding: 24px 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      @media screen and (max-width: 850px) {
        width: 100%;
        max-width: unset;
      }
    }
  }

  .item-right {
    margin-left: 12px;
    min-width: 120px;

    @media screen and (max-width: 850px) {
      margin-left: 0px;
    }

    .item-right-name {
      font-size: 20px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #040420;
      margin-bottom: 12px;
      @media screen and (max-width: 850px) {
        font-size: 18px;
      }
    }

    .item-right-name2 {
      font-size: 16px;
      font-family: Source Han Sans CN-Regular, Source Han Sans CN;
      font-weight: 400;
      color: #727272;
      @media screen and (max-width: 850px) {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }

  .map {
    margin-top: 32px;
    height: 368px;
    width: 100%;
    max-width: 1280px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    column-gap: 28px;

    background: #f0f2f9;

    .address {
      padding-left: 32px;
    }

    .two {
      margin-top: 36px;
    }

    .map-image {
      max-width: 695px;
      height: 100%;
    }

    @media screen and (max-width: 850px) {
      flex-direction: column;
      row-gap: 12px;
      height: auto;

      .address {
        width: 100%;
        padding: 14px;

        display: flex;
        flex-direction: column;
        row-gap: 28px;
      }

      .two {
        margin-top: 0;
      }

      .map-image {
        width: auto;
        height: 368px;
        max-width: unset;
      }
    }
  }

  //End of: .map;
}

:deep(.el-tabs) {
  display: flex;
  --el-tabs-header-height: 40px;
  flex-direction: column;
  align-items: center;
}

:deep(.el-tabs__header) {
  margin: 0px;
}

:deep(.el-tabs__content) {
  width: 100%;
}

:deep(.el-tabs .el-tabs__header) {
  width: 100%;
  max-width: 1280px;
  padding: 0px 30px;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

:deep(.el-tabs .el-tabs__nav) {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

:deep(.el-tabs__nav-wrap) {
  width: 100%;
}

:deep(.el-tabs__active-bar) {
  height: 2px;
  margin-bottom: 12px;
  background-color: #2e64f3;
}

:deep(.el-tabs .el-tabs__active-bar .is-top) {
  width: 90px;
}

:deep(.el-tabs .el-tabs__item) {
  width: 120px;
  text-align: center;
  height: 20px;
  font-size: 24px;
  font-family: Source Han Sans CN-Medium, Source Han Sans CN;
  font-weight: 500;

  line-height: 20px;

  padding: 20px 0 46px 0;
}

:deep(.el-tabs .el-tabs__item.is-active) {
  color: #2e64f3;
}
</style>
